
//1.Import
import "@lottiefiles/lottie-player";
import Layout from '../Layout';
import SectionLandingAbout from "../sections/SectionLandingAbout";
import SectionPoint from '../sections/SectionPoint';
import SectionLandingReviews from "../sections/SectionLandingReviews";
import SectionFlow from '../sections/SectionFlow';
import SectionQA from '../sections/SectionQA';

//2.Initialization
const layout = new Layout();
const sectionLandingAbout= new SectionLandingAbout();
const sectionPoint= new SectionPoint();
const sectionLandingReviews= new SectionLandingReviews();
const sectionFlow= new SectionFlow();
const sectionQA=new SectionQA();

//3.Events
window.addEventListener('DOMContentLoaded', function() {
    sectionLandingAbout.init();
    sectionPoint.init();
    sectionLandingReviews.init();
    sectionFlow.init();
    sectionQA.init();
});

